import { Box, Button, Typography, styled } from "@mui/material";

export const StyledInvoiceSettingsPanel = styled(Box)(({ theme }) => ({
  padding: theme.padding?.size?.medium ?? "16px",
  width: "100%",
  boxSizing: "border-box",
}));

export const StyledInvoiceSettingsHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.padding?.size?.large ?? "24px",
}));

export const StyledInvoiceSettingsTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette?.custom?.productTextColor ?? "#1E293B",
  fontSize: theme.typography?.medium?.fontSize ?? "18px",
  fontWeight: theme.typography?.fontWeight?.semiBold ?? 600,
  marginBottom: "6px",
}));

export const StyledInvoiceSettingsDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette?.custom?.lockerValueColor ?? "#64748B",
  fontSize: theme.typography?.regular?.fontSize ?? "14px",
  lineHeight: 1.5,
}));

export const StyledInvoiceSectionCard = styled(Box)(({ theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  border: `1px solid ${theme.palette?.custom?.lightPink ?? "#e2e8f0"}`,
  borderRadius: theme.borderRadius?.radius?.medium ?? "12px",
  backgroundColor: theme.palette?.custom?.white ?? "#fff",
  padding: theme.padding?.size?.medium ?? "16px",
  marginBottom: theme.padding?.size?.medium ?? "16px",
}));

export const StyledInvoiceSectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette?.custom?.primary ?? "#0B65B5",
  fontSize: theme.typography?.regular?.fontSize ?? "14px",
  fontWeight: theme.typography?.fontWeight?.semiBold ?? 600,
  marginBottom: theme.padding?.size?.medium ?? "16px",
  textTransform: "uppercase",
  letterSpacing: "0.4px",
}));

export const StyledInvoiceFieldRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: theme.padding?.size?.medium ?? "16px",
  width: "100%",
  marginBottom: theme.padding?.size?.medium ?? "16px",
  "& .MuiOutlinedInput-root": {
    minHeight: "48px",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const StyledInvoiceFieldRowTwo = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: theme.padding?.size?.medium ?? "16px",
  width: "100%",
  "& .MuiOutlinedInput-root": {
    minHeight: "48px",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const StyledInvoiceFullWidthField = styled(Box)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    minHeight: "48px",
  },
}));

export const StyledInvoiceActionsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: theme.padding?.size?.small ?? "8px",
  width: "100%",
}));

export const StyledInvoiceSaveButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography?.fontWeight?.semiBold ?? 600,
  fontSize: theme.typography?.regular?.fontSize ?? "14px",
  minWidth: "148px",
  height: "42px",
  borderRadius: theme.borderRadius?.radius?.wallet ?? "8px",
  backgroundColor: theme.palette?.custom?.primary ?? "#0B65B5",
  color: theme.palette?.custom?.white ?? "#fff",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette?.custom?.primary ?? "#0B65B5",
    opacity: 0.92,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette?.custom?.lightPink ?? "#cbd5e1",
    color: theme.palette?.custom?.white ?? "#fff",
  },
}));

export const StyledInvoiceLoaderWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "280px",
  padding: theme.padding?.size?.large ?? "24px",
  width: "100%",
}));
